import TopicsList from './TopicsList';

export default TopicsList;
